import { useState } from "react"
import { useFetch } from "../../../common/hooks/useFetch.js"
import Swal from "sweetalert2"
import { createVariousDocumentAdminService } from "../services/createVariousDocumentAdmin.service.js"
import { deleteVariousDocumentAdminService } from "../services/deleteVariousDocumentAdmin.service.js"

const initialState = {
  id: null,
  file: null,
  description: "",
  observations: ""
}

export const useVariousDocumentAdminlCommand = (refresh) => {
  const fetchData = useFetch()
  const [document, setDocument] = useState(initialState)
  const [errors, setErrors] = useState({ hasError: false, errors: {} })
  const [loading, setLoading] = useState(false)

  const handleChange = ({ name, value }) => {
    setDocument(prev => ({ ...prev, [name]: value }))
    setErrors(prev => ({ ...prev, errors: { ...prev.errors, [name]: "" } }))
  }

  const setStateDefault = (document) => {
    if (document) {
      setDocument(document)
      return;
    }

    setDocument(initialState)
  }

  const createDocument = async (document) => {
    try {
      setLoading(true)
      if (!validations(document)) return;

      const formData = new FormData()
      formData.append('description', document.description)
      if (document.observations) {
        formData.append('observations', document.observations)
      }
      formData.append('file', document.file)
      const response = await createVariousDocumentAdminService(fetchData)(formData)
      refresh?.()
      Swal.fire({
        icon: 'success',
        title: 'Documento creado',
        text: response.message
      })
      setDocument(initialState)
      return true;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message
      })

      throw error
    } finally {
      setLoading(false)
    }
  }

  const deleteDocument = async (id) => {
    try {
      setLoading(true)
      const response = await deleteVariousDocumentAdminService(fetchData)(id)
      refresh?.()
      Swal.fire({
        icon: 'success',
        title: 'Documento eliminado',
        text: response.message
      })
      return true;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message
      })
    } finally {
      setLoading(false)
    }
  }

  const validations = (document) => {
    const newErrors = {}

    if (!document.description) {
      newErrors.description = "La descripcion es requerida"
    }

    if (!document.file) {
      newErrors.file = "El archivo es requerido"
    }

    const hasError = Object.keys(newErrors).length > 0
    setErrors({ hasError, errors: newErrors })
    return !hasError
  }

  return {
    document,
    errors,
    loading,
    handleChange,
    setStateDefault,
    createDocument,
    deleteDocument
  }
}
